import React from "react";
import PhaseReadingChart from "./PhaseReadingChart";
import { images } from "../../common/images";

const FREQUENCY_DECIMALS = { axis: 1, tooltip: 2 };

// 49-51 Hz is a stable supply; outside it is unstable.
const FREQUENCY_RANGE = {
  low: 49,
  high: 51,
  normalLabel: "Stable",
  outLabel: "Unstable",
  lowLabel: "Unstable (low)",
  highLabel: "Unstable (high)",
};

export default function FrequencyLineChart({ selectedDeviceSelectedDayData }) {
  return (
    <PhaseReadingChart
      selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
      reading="f"
      name="Frequency"
      image={images.chartFrequency}
      iconBackgroundColor="rgba(106, 77, 245, 0.10)"
      unit="Hz"
      axisTitle="Hertz (Hz)"
      range={FREQUENCY_RANGE}
      decimals={FREQUENCY_DECIMALS}
    />
  );
}
